export default __webpack_public_path__ + "static/media/megaphone.788ab45f.svg";